import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';

export const HelpfulText = styled.span`
  color: ${p => p.theme.text.quaternary};
`;

type HelpfulButtonProps = {
  liked: boolean;
};

export const HelpfulButton = styled.button<HelpfulButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${p =>
    p.liked ? p.theme.text.callToActionHover : p.theme.text.callToAction};
  cursor: pointer;
  padding: ${layout.spacing.xSmall};
  padding-left: 0;

  ${HelpfulText} {
    overflow: hidden;
    transition: max-width 150ms ease;
    max-width: ${p => (p.liked ? 0 : '999px')};
    white-space: nowrap;
    line-height: normal;
  }

  && {
    svg {
      margin-left: ${p => (p.liked ? 0 : layout.spacing.xSmall)};
      margin-right: ${layout.spacing.xxSmall};
    }
  }

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const Count = styled.span`
  font-weight: 600;
`;
